export var IBrandCart;
(function (IBrandCart) {
    let State;
    (function (State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        /**
         * The brand cart is part of the currently active cart of the retailer and IS NOT saved for later.
         */
        State["ACTIVE"] = "ACTIVE";
        /**
         * The brand cart is part of the currently active cart of the retailer and IS saved for later.
         */
        State["SAVED_FOR_LATER"] = "SAVED_FOR_LATER";
        /**
         * The brand cart has been checked out.
         */
        State["CHECKED_OUT"] = "CHECKED_OUT";
    })(State = IBrandCart.State || (IBrandCart.State = {}));
    /**
     * Return an instance of IBrandCart with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IBrandCart.build = (partial) => (Object.assign({ items: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IBrandCart || (IBrandCart = {}));
